import React from 'react'
import { DcButton, DcDropDown, DcInput, PixelFactoryContext } from 'pixel-base'
import styled from 'styled-components'

import { createCategory } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const CategoryForm = (props) => {
  const { handleClose, categories } = props
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [data, setData] = React.useState({
    category_name: '',
    parent_id: 0,
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    handleAdd()
  }

  const handleAdd = () => {
    showPageLoader()
    createCategory(data).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully Added')
        setData({
          category_name: data.category_name,
          parent_id: data.parent_id,
        })
        handleClose(res.response.data, 'add')
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <DcInput
            error={
              error.field === 'category_name' && error.error !== ''
                ? error.error
                : null
            }
            required
            type={'text'}
            name={'Category Name'}
            placeholder={'Category Name'}
            value={data.category_name}
            onChange={(e) =>
              setData({ ...data, category_name: e.target.value })
            }
          />
        </FormGroup>

        <FormGroup>
          <DcDropDown
            error={
              error.field === 'parent_id' && error.error !== ''
                ? error.error
                : null
            }
            required
            options={[...categories].map((status) => ({
              label: status.name,
              value: status.id,
            }))}
            value={data.parent_id}
            onChange={(e) => {
              setData({ ...data, parent_id: e.target.value })
            }}
            placeholder={'Select Category'}
          />
        </FormGroup>
        <FormGroup flexEnd>
          <DcButton variant="primary" type="submit">
            Add
          </DcButton>
        </FormGroup>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default CategoryForm
